import * as React from 'react';
import {observer} from "mobx-react-lite";
import {Target} from "../models/ioc";
import {Badge, OverlayTrigger, Popover} from "react-bootstrap";

const TargetRow = observer(function TargetRow(props: {target: Target}) {
    const color = props.target.danger_level > 4 ? 'danger' : props.target.danger_level > 2 ? 'warning' : 'secondary'

    return <OverlayTrigger
        placement="bottom"
        overlay={
            <Popover id="targetDescriptionTooltip">
                <Popover.Content>
                    {props.target.public_description}
                </Popover.Content>
            </Popover>
        }
    >
        <Badge className="targetBadge targets-list" variant={color}>
            {props.target.short_description}
        </Badge>
    </OverlayTrigger>
});

export default TargetRow